import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';

import {
  HsLanguageModule,
  HsLayoutModule,
  HsPanelHelpersModule,
} from 'hslayers-ng';

import {AdjusterAdvancedPanelComponent} from './adjuster-advanced-panel/adjuster-advanced-panel.component';
import {AdjusterLoaderComponent} from './adjuster-loader/adjuster-loader.component';
import {AdjusterSimplePanelComponent} from './adjuster-simple-panel/adjuster-simple-panel.component';
import {DatasetItemComponent} from './dataset-item/dataset-item.component';
import {DatasetListComponent} from './dataset-list/dataset-list.component';
import {MetadataDialogComponent} from './metadata-dialog/metadata-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HsLanguageModule,
    HsLayoutModule,
    HsPanelHelpersModule,
    NgbModule,
    TranslateModule,
  ],
  exports: [AdjusterAdvancedPanelComponent, AdjusterSimplePanelComponent],
  declarations: [
    AdjusterAdvancedPanelComponent,
    AdjusterLoaderComponent,
    AdjusterSimplePanelComponent,
    DatasetListComponent,
    DatasetItemComponent,
    MetadataDialogComponent,
  ],
})
export class AdjusterModule {}
